export default "__VITE_ASSET__DXCGpbG3__"